import {
  FETCH_CONSTITUENCIES_REQUEST,
  FETCH_CONSTITUENCIES_SUCCESS,
  FETCH_CONSTITUENCIES_FAILURE,
  CREATE_CONSTITUENCY_REQUEST,
  CREATE_CONSTITUENCY_SUCCESS,
  CREATE_CONSTITUENCY_FAILURE,
} from "../../actions/user-management/constituencyActions";

const initialState = {
  loading: false,
  constituencies: [],
  pagination: { page: 1, limit: 10, totalRecords: 0, totalPages: 0 },
  error: null,
};

const constituencyReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CONSTITUENCIES_REQUEST:
    case CREATE_CONSTITUENCY_REQUEST:
      return { ...state, loading: true, error: null };

    case FETCH_CONSTITUENCIES_SUCCESS:
      return {
        ...state,
        loading: false,
        constituencies: action.payload.data,
        pagination: action.payload.pagination,
        error: null,
      };

    case CREATE_CONSTITUENCY_SUCCESS:
      return {
        ...state,
        loading: false,
        // Optionally add the new item to the list if we want immediate UI update
        // We'll rely on refetch after creation in the component
        error: null,
      };
      return {
        ...state,
        loading: false,
        // Update the list in place for immediate UI update
        constituencies: state.constituencies.map((item) =>
          item.id === action.payload.id ? action.payload : item,
        ),
        error: null,
      };

    case FETCH_CONSTITUENCIES_FAILURE:
    case CREATE_CONSTITUENCY_FAILURE:
      return { ...state, loading: false, error: action.error };

    default:
      return state;
  }
};

export default constituencyReducer;
